<template>
  <div class="container">
    <!-- Vision Input Field -->
    <h2 class="subgroupname">{{ usergroup_name }}</h2>
    <b-row class="my-2">
      <b-col>
        <b-form-group>
          <template v-slot:label>
            <span class="title">
              VISION
            </span>
            <i style="font-size: 16px!important;color: #007bff;" v-if="!isVisionEditable" @click="toggleVisionEdit" class="far fa-edit"></i>
          </template>
          <b-form-textarea 
            v-model="vision" 
            placeholder="Enter vision..." 
            rows="4" 
            class="full-width-textarea"
            :readonly="!isVisionEditable">
          </b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>

    <!-- Mission Input Field -->
    <b-row class="my-2">
      <b-col>
        <b-form-group>
          <template v-slot:label>
            <span class="title">
              MISSION
            </span>
            <i style="font-size: 16px!important;color: #007bff;" v-if="!isMissionEditable" @click="toggleMissionEdit" class="far fa-edit"></i>
          </template>
          <b-form-textarea 
            v-model="mission" 
            placeholder="Enter mission..." 
            rows="4" 
            class="full-width-textarea"
            :readonly="!isMissionEditable">
          </b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>

    <!-- Update Button -->
    <b-row class="my-2">
      <b-col class="text-right">
        <b-button variant="primary" @click="setInstitutionVisionMission">Update</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["usergroup_name", "usergroup_id"],
  async created() {
    await this.getInstitutionVision();
    await this.getInstitutionMission();
  },
  data() {
    return {
      vision: "",
      mission: "",
      isVisionEditable: false,
      isMissionEditable: false,
    };
  },
  methods: {
    async getInstitutionVision() {
      const settingKey = "vision";
      let mainUrl = this.$store.getters.getAPIKey.institutionSettings;
      const url = mainUrl.replace("setting_key", settingKey);
      await axios
        .get(url)
        .then((response) => {
          this.vision = response.data;
        })
        .catch(() => {
          // console.log(error.response);
        });
    },
    async getInstitutionMission() {
      const settingKey = "mission";
      let mainUrl = this.$store.getters.getAPIKey.institutionSettings;
      const url = mainUrl.replace("setting_key", settingKey);
      await axios
        .get(url)
        .then((response) => {
          this.mission = response.data;
        })
        .catch(() => {
          // console.log(error.response);
        });
    },

    async setInstitutionVisionMission() {
      if(this.isVisionEditable){
        await this.setInstitutionVision();
      } 
      if(this.isMissionEditable){
        await this.setInstitutionMission();
      }
    },
    async setInstitutionVision() {
      const settingKey = "vision";
      let mainUrl = this.$store.getters.getAPIKey.institutionSettings;
      const url = mainUrl.replace("setting_key", settingKey);
      try {
        await this.$axios.post(url, {
          vision: this.vision,
        });
        this.$toast.success("Vision Updated", {
          position: "top",
          duration: 3000,
        });
        this.isVisionEditable = false; // Disable editing after update
      } catch (error) {
        error;
      }
    },

    async setInstitutionMission() {
      const settingKey = "mission";
      let mainUrl = this.$store.getters.getAPIKey.institutionSettings;
      const url = mainUrl.replace("setting_key", settingKey);
      try {
        await this.$axios.post(url, {
          mission: this.mission,
        });
        this.$toast.success("Mission Updated", {
          position: "top",
          duration: 3000,
        });
        this.isMissionEditable = false; // Disable editing after update
      } catch (error) {
        error;
      }
    },

    toggleVisionEdit() {
      this.isVisionEditable = !this.isVisionEditable;
    },

    toggleMissionEdit() {
      this.isMissionEditable = !this.isMissionEditable;
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 100%;
  padding: 20px;
}

.title {
  font-size: 18px;
  text-decoration: underline;
  font-weight: bold;
  color: #007bff;
}

.full-width-textarea {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px;
  font-size: 16px;
  min-height: 100px;
  resize: none;
}

.subgroupname {
  font-weight: bold;
  text-align: center;
  color: #007bff; /* Bootstrap primary color */
  text-transform: uppercase;
}
</style>
